var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-top": "10px" } },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "error-form",
          attrs: { model: _vm.formData, "label-width": "0", size: "mini" },
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.formData.arr, border: "" } },
            [
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "120" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "arr." + scope.$index + ".feeTypeCode",
                                rules: _vm.feeTypeCodeRules,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "basicData.PleaseSelect"
                                    ),
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleChange(
                                        $event,
                                        scope.$index
                                      )
                                    },
                                  },
                                  model: {
                                    value: scope.row.feeTypeCode,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "feeTypeCode", $$v)
                                    },
                                    expression: "scope.row.feeTypeCode",
                                  },
                                },
                                _vm._l(_vm.enabledFeeList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: _vm.getFeeTypeLabel(item),
                                      value: item.code,
                                      disabled: _vm.isFeeTypeDisabled(
                                        item.code,
                                        scope.row.feeTypeCode,
                                        scope.$index
                                      ),
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("basicData.ExpenseType"))),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
              _c(
                "el-table-column",
                {
                  attrs: { "min-width": "300" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "feet-r" }, [
                            scope.row.specialRules === 2
                              ? _c(
                                  "div",
                                  { staticClass: "feet-r" },
                                  [
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "arr." +
                                            scope.$index +
                                            ".startNumber",
                                          rules: _vm.getRangeRules(
                                            scope.row.endNumber,
                                            "start"
                                          ),
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            min: 0.1,
                                            max: _vm.MAX_NUMBER,
                                            precision: 1,
                                            controls: false,
                                            placeholder: _vm.$t(
                                              "basicData.PleaseEnter"
                                            ),
                                          },
                                          model: {
                                            value: scope.row.startNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "startNumber",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.startNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        " < " +
                                          _vm._s(
                                            _vm.$t(
                                              "basicData.delayTimeCalculation"
                                            ) + " ≤ "
                                          )
                                      ),
                                    ]),
                                    _c(
                                      "el-form-item",
                                      {
                                        attrs: {
                                          prop:
                                            "arr." +
                                            scope.$index +
                                            ".endNumber",
                                          rules: _vm.getRangeRules(
                                            scope.row.startNumber,
                                            "end"
                                          ),
                                        },
                                      },
                                      [
                                        _c("el-input-number", {
                                          attrs: {
                                            min: 0.2,
                                            max: _vm.MAX_NUMBER,
                                            precision: 1,
                                            controls: false,
                                            placeholder: _vm.$t(
                                              "basicData.PleaseEnter"
                                            ),
                                          },
                                          model: {
                                            value: scope.row.endNumber,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "endNumber",
                                                $$v
                                              )
                                            },
                                            expression: "scope.row.endNumber",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "basicData.penaltyAmountFormula"
                                          ) + "*"
                                        )
                                      ),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              { staticClass: "flex" },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      prop:
                                        "arr." +
                                        scope.$index +
                                        ".deliveryFeeRatio",
                                      rules: _vm.deliveryFeeRatioRules,
                                    },
                                  },
                                  [
                                    _c(
                                      "el-input",
                                      {
                                        staticStyle: { width: "120px" },
                                        attrs: {
                                          placeholder: _vm.$t(
                                            "basicData.PleaseEnter"
                                          ),
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.handleDeliveryFeeRatioInput(
                                              $event,
                                              scope.$index
                                            )
                                          },
                                        },
                                        model: {
                                          value: scope.row.deliveryFeeRatio,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "deliveryFeeRatio",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.deliveryFeeRatio",
                                        },
                                      },
                                      [
                                        _c("template", { slot: "append" }, [
                                          _vm._v("%"),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "header" }, [
                    _c("div", [
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v("*"),
                      ]),
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("basicData.BillingRules")) + "(%)"
                        ),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
              _c("el-table-column", {
                attrs: { width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "danger" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDel(scope.$index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("basicData.Delete")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }